import { z } from 'zod';
import { paginationQuerySchema } from '../common/pagination.js';
/**
 * Xodimlar ro'yxati so'rovi.
 *
 * `q` bitta maydon: administrator ismni ham, loginni ham, JSHSHIR ni ham SHU
 * YERGA yozadi.
 * Ikkita alohida maydon berilsa, foydalanuvchi qaysi biriga yozishni o'ylab
 * o'tirardi — qidiruv esa ikkalasini ham qamraydi.
 */
export const userListQuerySchema = paginationQuerySchema.extend({
    q: z.string().trim().max(100).optional(),
});
//# sourceMappingURL=user.js.map